import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./hexaExchange-logo.jpg"
								alt="hexaExchange"
								className="work-image"
							/>
							<div className="work-title">Hexa Exchange</div>
							<div className="work-subtitle">
								Software Developer
							</div>
							<div className="work-duration">2019 - 2020	</div>
						</div>

					</div>
				}
			/>
		</div>
	);
};

export default Works;
